import { down, up } from 'styled-breakpoints'
import styled from 'styled-components'

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;
  padding: 20px;
  width: 100%;
  background-color: #f8fafc;
  ${up('md')} {
    justify-content: center;
    flex-direction: row;
    align-items: flex-start;
  }
`

export const Message = styled.div`
  font-size: 42px;
  font-weight: 800;
  color: #0f172a;
`

export const HomeStyles = {
  Row: styled.div``,
  ContentInner: styled.div``,
  Label: styled.div``,
}

export const FilterStyles = {
  Content: styled.div`
    padding: 18px;
    display: flex;
    gap: 15px;
    width: 100%;
    flex-direction: column;
    align-items: center;
  `,
  Title: styled.div`
    color: #0f172a;
    font-size: 20px;
    font-style: normal;
    font-weight: 700;
    line-height: normal;
  `,
}
export const ChartStyle = {
  Content: styled.div`
    height: fit-content;
    width: 33%;
    ${down('md')} {
      width: 100%;
    }
  `,
}

export const ChartTitle = styled.div`
  color: #0f172a;
  font-size: 16px;
  font-weight: 700;
  text-align: center;
  border: none;
  padding: 20px;
  border-bottom: 1px solid #e2e8f0;
`

export const DashStyles = {
  LeftPanel: styled.div`
    display: flex;
    flex-wrap: wrap;
    flex-direction: row;
    border-radius: 16px;
    background-color: #ffffff;
    width: 75%;
    height: 100%;
    border: 1px solid #e2e8f0;
    box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.05);
    ${down('md')} {
      width: 100%;
      height: fit-content;
    }
  `,
  RightPanel: styled.div<{ hidden: boolean }>`
    width: 25%;
    border-radius: 16px;
    background-color: #ffffff;
    border: 1px solid #e2e8f0;
    box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.05);
    height: 100%;
    ${down('md')} {
      width: 100%;
    }
    ${({ hidden }) => hidden && `display: none`}
  `,
  Label: styled.div``,
}
